import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatLegacySliderModule as MatSliderModule } from '@angular/material/legacy-slider';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ng2TelInputModule } from 'ng2-tel-input';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';

import { HelpLineComponent } from './addons/help-line/help-line.component';
import { TextBoxComponent } from './text-box/text-box.component';
import { TextAreaComponent } from './text-area/text-area.component';
import { DropDownComponent } from './drop-down/drop-down.component';
import { AutoCompleteComponent } from './auto-complete/auto-complete.component';
import { InternationalPhoneNumberComponent } from './international-phone-number/international-phone-number.component';
import { DatePickerComponent } from './date-picker/date-picker.component';
import { RadioComponent } from './radio/radio.component';
import { CheckBoxComponent } from './check-box/check-box.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { BuilderService } from './utilities/services/builder.service';
import { FunctionsService } from './utilities/services/functions.service';
import { OwlDatePickerComponent } from './owl-date-picker/owl-date-picker.component';
import { ImageCropComponent } from './image-crop/image-crop.component';
import { MatRatingComponent } from './mat-rating/mat-rating.component';
import { MatNativeDateModule } from '@angular/material/core';
import { PipeModule } from '@app/system/pipes/pipe.module';
import { VideoUploadComponent } from './video-upload/video-upload.component';
import { DirectivesModule } from '@app/system/directives/directives.module';
import { PopupComponent } from './video-upload/popup/popup.component';
import { AudioUploadComponent } from './audio-upload/audio-upload.component';
import { VideoRecorderComponent } from './video-recorder/video-recorder.component';
import { EmbedComponent } from './embed/embed.component';
import { AdvancedSearchComponent } from './advanced-search/advanced-search.component';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { ChipsModule } from '../chips/chips.module';
import { WeightageComponent } from './weightage/weightage.component';
import { PopupComponent as WeightagePopupComponent } from './weightage/popup/popup.component';
import { QuillEditorComponent } from './quill-editor/quill-editor.component';
import { QuillModule } from 'ngx-quill';
import { ImageUploadComponent } from './image-upload/image-upload.component';
import { MultiTypeUploadComponent } from './multi-type-upload/multi-type-upload.component';
import { MatRippleModule } from '@angular/material/core';
import { PopupComponent as ImageUploadPopupComponent } from './image-upload/popup/popup.component';
import { SkillsSelectionComponent } from './skills-selection/skills-selection.component';

@NgModule({
    declarations: [
        HelpLineComponent,
        TextBoxComponent,
        TextAreaComponent,
        DropDownComponent,
        AutoCompleteComponent,
        InternationalPhoneNumberComponent,
        DatePickerComponent,
        RadioComponent,
        CheckBoxComponent,
        FileUploadComponent,
        OwlDatePickerComponent,
        ImageCropComponent,
        MatRatingComponent,
        VideoUploadComponent,
        PopupComponent,
        AudioUploadComponent,
        VideoRecorderComponent,
        EmbedComponent,
        AdvancedSearchComponent,
        WeightageComponent,
        WeightagePopupComponent,
        QuillEditorComponent,
        ImageUploadComponent,
        MultiTypeUploadComponent,
        ImageUploadPopupComponent,
        SkillsSelectionComponent
    ],
    imports: [
        CommonModule,
        FlexLayoutModule,
        MatFormFieldModule,
        MatTooltipModule,
        MatInputModule,
        MatSelectModule,
        MatIconModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatCheckboxModule,
        MatRadioModule,
        MatButtonModule,
        MatAutocompleteModule,
        MatChipsModule,
        FormsModule,
        ReactiveFormsModule,
        Ng2TelInputModule,
        MatChipsModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        MatSliderModule,
        PipeModule,
        DirectivesModule,
        MatMenuModule,
        MatProgressSpinnerModule,
        ChipsModule,
        QuillModule.forRoot(),
        MatRippleModule
    ],
    exports: [
        TextBoxComponent,
        TextAreaComponent,
        DropDownComponent,
        AutoCompleteComponent,
        InternationalPhoneNumberComponent,
        DatePickerComponent,
        RadioComponent,
        CheckBoxComponent,
        FileUploadComponent,
        VideoUploadComponent,
        OwlDatePickerComponent,
        ImageCropComponent,
        MatRatingComponent,
        AudioUploadComponent,
        VideoRecorderComponent,
        EmbedComponent,
        AdvancedSearchComponent,
        QuillEditorComponent,
        WeightageComponent,
        ImageUploadComponent,
        MultiTypeUploadComponent,
        SkillsSelectionComponent
    ],
    providers: [BuilderService, FunctionsService]
})
export class ControlsModule { }
